import React from 'react'
import PropTypes from 'prop-types'

import { ResourceDetailsBlock } from '../../ProjectDescription.styles'

const Description = ({ numberOfWells, productivity, lang }) => {
  return (
    <>
      <ResourceDetailsBlock>
        <span className="label">
          {lang === 'en' ? `Number of Wells` : `عدد الآبار`}
        </span>
        <span className="value">{numberOfWells}</span>
      </ResourceDetailsBlock>
      <ResourceDetailsBlock>
        <span className="label">
          {lang === 'en' ? `Productivity (m³/year)` : `الإنتاجية (م٣ في السنة)`}
        </span>
        <span className="value">{productivity}</span>
      </ResourceDetailsBlock>
    </>
  )
}

Description.propTypes = {
  numberOfWells: PropTypes.string,
  productivity: PropTypes.string,
  lang: PropTypes.string
}

export default Description
